import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICardData } from '../../../../../pipeline/interfaces/pipeline-data';
import { CustomDashboardsService } from '../../../../services/my-limegear.service';
import {PipelineLockStatusService} from "app/modules/pipeline/services/pipeline-lock-status.service";

@Component({
    selector: 'pipeline-by-lock-status-simpletablecard',
    templateUrl: './pipeline-by-lock-status-stc.component.html',
    styleUrls: ['./pipeline-by-lock-status-stc.component.scss'],
})
export class PipelineByLockStatusSimpletablecardComponent implements OnInit {
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _cardService: PipelineLockStatusService,
        private _router: Router
    ) {}

    cardData: ICardData;

    ngOnInit() {
        let navFromUrl = this._router.url.split('?')[0];
        this.cardData = {
            cardId: 'pipelineByLockStatus',
            title: 'Pipeline by Lock Status',
            isChartCard: false,
            urlSegment: 'insights_pipelineByLoanStatus',
            drilldownUrl: '/reporting/pipeline/',
            navFromUrl: navFromUrl,
            showPercentages: true,
        };

        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this._cardService.getPipelineLockStatusSimpleCardData(
                this.cardData,
                changes.displayOptions,
                changes.hierarchyfilters,
                changes.action,
                'lockStatus'
            );
        });
    }
}
